declare namespace $ {

	type $mol_view__event_shm_hitalama_map_float_1 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_float['pointerdown'] > ): ReturnType< $shm_hitalama_map_float['pointerdown'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__style_shm_hitalama_map_float_2 = $mol_type_enforce<
		({ 
			'transform': ReturnType< $shm_hitalama_map_float['resizer_line_y_transform'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__style_shm_hitalama_map_float_3 = $mol_type_enforce<
		({ 
			'transform': ReturnType< $shm_hitalama_map_float['resizer_line_x_transform'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__style_shm_hitalama_map_float_4 = $mol_type_enforce<
		({ 
			'transform': ReturnType< $shm_hitalama_map_float['resizer_line_y_transform'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__style_shm_hitalama_map_float_5 = $mol_type_enforce<
		({ 
			'transform': ReturnType< $shm_hitalama_map_float['resizer_line_x_transform'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__style_shm_hitalama_map_float_6 = $mol_type_enforce<
		({ 
			'transform': ReturnType< $shm_hitalama_map_float['toolbar_transform'] >,
			'top': ReturnType< $shm_hitalama_map_float['toolbar_style_top'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_hitalama_map_float_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['toolbar_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_map_float_resizer__repos_x_shm_hitalama_map_float_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_x'] >
	>
	type $shm_hitalama_map_float_resizer__repos_y_shm_hitalama_map_float_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_y'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_start_shm_hitalama_map_float_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_start'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_start'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_end_shm_hitalama_map_float_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_end'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_end'] >
	>
	type $shm_hitalama_map_float_resizer__y_shm_hitalama_map_float_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['top_edge_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['y'] >
	>
	type $shm_hitalama_map_float_resizer__transform_shm_hitalama_map_float_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resizer_line_y_transform'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['transform'] >
	>
	type $shm_hitalama_map_float_resizer__repos_x_shm_hitalama_map_float_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_x'] >
	>
	type $shm_hitalama_map_float_resizer__repos_y_shm_hitalama_map_float_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_y'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_start_shm_hitalama_map_float_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_start'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_start'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_end_shm_hitalama_map_float_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_end'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_end'] >
	>
	type $shm_hitalama_map_float_resizer__x_shm_hitalama_map_float_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['left_edge_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['x'] >
	>
	type $shm_hitalama_map_float_resizer__transform_shm_hitalama_map_float_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resizer_line_x_transform'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['transform'] >
	>
	type $shm_hitalama_map_float_resizer__repos_x_shm_hitalama_map_float_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_x'] >
	>
	type $shm_hitalama_map_float_resizer__repos_y_shm_hitalama_map_float_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_y'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_start_shm_hitalama_map_float_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_start'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_start'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_end_shm_hitalama_map_float_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_end'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_end'] >
	>
	type $shm_hitalama_map_float_resizer__y_shm_hitalama_map_float_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['bottom_edge_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['y'] >
	>
	type $shm_hitalama_map_float_resizer__transform_shm_hitalama_map_float_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resizer_line_y_transform'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['transform'] >
	>
	type $shm_hitalama_map_float_resizer__repos_x_shm_hitalama_map_float_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_x'] >
	>
	type $shm_hitalama_map_float_resizer__repos_y_shm_hitalama_map_float_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_y'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_start_shm_hitalama_map_float_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_start'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_start'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_end_shm_hitalama_map_float_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_end'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_end'] >
	>
	type $shm_hitalama_map_float_resizer__x_shm_hitalama_map_float_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['right_edge_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['x'] >
	>
	type $shm_hitalama_map_float_resizer__transform_shm_hitalama_map_float_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resizer_line_x_transform'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['transform'] >
	>
	type $shm_hitalama_map_float_resizer__repos_x_shm_hitalama_map_float_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_x'] >
	>
	type $shm_hitalama_map_float_resizer__repos_y_shm_hitalama_map_float_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_y'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_start_shm_hitalama_map_float_34 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_start'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_start'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_end_shm_hitalama_map_float_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_end'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_end'] >
	>
	type $shm_hitalama_map_float_resizer__y_shm_hitalama_map_float_36 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['top_left_edge_ratio_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['y'] >
	>
	type $shm_hitalama_map_float_resizer__transform_shm_hitalama_map_float_37 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resizer_line_y_transform'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['transform'] >
	>
	type $shm_hitalama_map_float_resizer__repos_x_shm_hitalama_map_float_38 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_x'] >
	>
	type $shm_hitalama_map_float_resizer__repos_y_shm_hitalama_map_float_39 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_y'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_start_shm_hitalama_map_float_40 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_start'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_start'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_end_shm_hitalama_map_float_41 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_end'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_end'] >
	>
	type $shm_hitalama_map_float_resizer__y_shm_hitalama_map_float_42 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['top_right_edge_ratio_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['y'] >
	>
	type $shm_hitalama_map_float_resizer__transform_shm_hitalama_map_float_43 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resizer_line_y_transform'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['transform'] >
	>
	type $shm_hitalama_map_float_resizer__repos_x_shm_hitalama_map_float_44 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_x'] >
	>
	type $shm_hitalama_map_float_resizer__repos_y_shm_hitalama_map_float_45 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_y'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_start_shm_hitalama_map_float_46 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_start'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_start'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_end_shm_hitalama_map_float_47 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_end'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_end'] >
	>
	type $shm_hitalama_map_float_resizer__y_shm_hitalama_map_float_48 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['bottom_left_edge_ratio_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['y'] >
	>
	type $shm_hitalama_map_float_resizer__transform_shm_hitalama_map_float_49 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resizer_line_y_transform'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['transform'] >
	>
	type $shm_hitalama_map_float_resizer__repos_x_shm_hitalama_map_float_50 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_x'] >
	>
	type $shm_hitalama_map_float_resizer__repos_y_shm_hitalama_map_float_51 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_y'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_start_shm_hitalama_map_float_52 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_start'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_start'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_end_shm_hitalama_map_float_53 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_end'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_end'] >
	>
	type $shm_hitalama_map_float_resizer__y_shm_hitalama_map_float_54 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['bottom_right_edge_ratio_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['y'] >
	>
	type $shm_hitalama_map_float_resizer__transform_shm_hitalama_map_float_55 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resizer_line_y_transform'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['transform'] >
	>
	type $shm_hitalama_map_float_resizer__repos_x_shm_hitalama_map_float_56 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_x'] >
	>
	type $shm_hitalama_map_float_resizer__repos_y_shm_hitalama_map_float_57 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_y'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_start_shm_hitalama_map_float_58 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_start'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_start'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_end_shm_hitalama_map_float_59 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_end'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_end'] >
	>
	type $shm_hitalama_map_float_resizer__y_shm_hitalama_map_float_60 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['top_edge_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['y'] >
	>
	type $shm_hitalama_map_float_resizer__x_shm_hitalama_map_float_61 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['left_edge_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['x'] >
	>
	type $shm_hitalama_map_float_resizer__transform_shm_hitalama_map_float_62 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resizer_transform'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['transform'] >
	>
	type $shm_hitalama_map_float_resizer__repos_x_shm_hitalama_map_float_63 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_x'] >
	>
	type $shm_hitalama_map_float_resizer__repos_y_shm_hitalama_map_float_64 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_y'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_start_shm_hitalama_map_float_65 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_start'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_start'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_end_shm_hitalama_map_float_66 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_end'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_end'] >
	>
	type $shm_hitalama_map_float_resizer__y_shm_hitalama_map_float_67 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['top_edge_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['y'] >
	>
	type $shm_hitalama_map_float_resizer__x_shm_hitalama_map_float_68 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['right_edge_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['x'] >
	>
	type $shm_hitalama_map_float_resizer__transform_shm_hitalama_map_float_69 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resizer_transform'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['transform'] >
	>
	type $shm_hitalama_map_float_resizer__repos_x_shm_hitalama_map_float_70 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_x'] >
	>
	type $shm_hitalama_map_float_resizer__repos_y_shm_hitalama_map_float_71 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_y'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_start_shm_hitalama_map_float_72 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_start'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_start'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_end_shm_hitalama_map_float_73 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_end'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_end'] >
	>
	type $shm_hitalama_map_float_resizer__y_shm_hitalama_map_float_74 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['bottom_edge_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['y'] >
	>
	type $shm_hitalama_map_float_resizer__x_shm_hitalama_map_float_75 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['left_edge_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['x'] >
	>
	type $shm_hitalama_map_float_resizer__transform_shm_hitalama_map_float_76 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resizer_transform'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['transform'] >
	>
	type $shm_hitalama_map_float_resizer__repos_x_shm_hitalama_map_float_77 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_x'] >
	>
	type $shm_hitalama_map_float_resizer__repos_y_shm_hitalama_map_float_78 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['repos_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['repos_y'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_start_shm_hitalama_map_float_79 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_start'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_start'] >
	>
	type $shm_hitalama_map_float_resizer__on_drag_end_shm_hitalama_map_float_80 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resize_end'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['on_drag_end'] >
	>
	type $shm_hitalama_map_float_resizer__y_shm_hitalama_map_float_81 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['bottom_edge_y'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['y'] >
	>
	type $shm_hitalama_map_float_resizer__x_shm_hitalama_map_float_82 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['right_edge_x'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['x'] >
	>
	type $shm_hitalama_map_float_resizer__transform_shm_hitalama_map_float_83 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_float['resizer_transform'] >
		,
		ReturnType< $shm_hitalama_map_float_resizer['transform'] >
	>
	export class $shm_hitalama_map_float extends $rise_resize_ratio {
		transition_smooth( ): string
		transition( ): ReturnType< $shm_hitalama_map_float['transition_smooth'] >
		pointerdown( next?: any ): any
		Drag_overlap( ): $mol_view
		resizer_line_y_transform( ): string
		Outline_top( ): $mol_view
		resizer_line_x_transform( ): string
		Outline_left( ): $mol_view
		Outline_bottom( ): $mol_view
		Outline_right( ): $mol_view
		toolbar_transform( ): string
		toolbar_style_top( ): string
		toolbar_content( ): readonly(any)[]
		Toolbar( ): $mol_view
		Sidebar( ): $mol_view
		resizer_transform( ): string
		Map_page( ): $shm_hitalama_map_page
		stickable( next?: boolean ): boolean
		zoom( ): number
		style( ): ({ 
			'transition': ReturnType< $shm_hitalama_map_float['transition'] >,
		})  & ReturnType< $rise_resize_ratio['style'] >
		sub_common( ): readonly(any)[]
		outline( ): readonly(any)[]
		toolbar( ): readonly(any)[]
		sidebar( ): readonly(any)[]
		Top_edge( ): $shm_hitalama_map_float_resizer
		Left_edge( ): $shm_hitalama_map_float_resizer
		Bottom_edge( ): $shm_hitalama_map_float_resizer
		Right_edge( ): $shm_hitalama_map_float_resizer
		Top_left_edge_ratio( ): $shm_hitalama_map_float_resizer
		Top_right_edge_ratio( ): $shm_hitalama_map_float_resizer
		Bottom_left_edge_ratio( ): $shm_hitalama_map_float_resizer
		Bottom_right_edge_ratio( ): $shm_hitalama_map_float_resizer
		Top_left_edge( ): $shm_hitalama_map_float_resizer
		Top_right_edge( ): $shm_hitalama_map_float_resizer
		Bottom_left_edge( ): $shm_hitalama_map_float_resizer
		Bottom_right_edge( ): $shm_hitalama_map_float_resizer
	}
	
	export class $shm_hitalama_map_float_resizer extends $rise_resize_edge {
		transform( ): string
		style( ): ({ 
			'transform': ReturnType< $shm_hitalama_map_float_resizer['transform'] >,
		})  & ReturnType< $rise_resize_edge['style'] >
	}
	
}

//# sourceMappingURL=float.view.tree.d.ts.map